<template>
	<div class="poi-container" v-if="poi">
        <div class="poi">
			<div class="poi-image" :style="{'background-image': getImage()}"></div>
			<div class="poi-name" v-html="poi.getName(language) || 'POI'"></div>
			<div class="poi-floor"><label v-if="poi.getFloor()" v-html="poi.getFloor().getName(language) || ''"></label></div>
		</div>
        <div class="poi-footer">
			<icon name="clock"/>
			<label class="normal" v-if="poi.opening_times && !poi.opening_times['24h']">{{poi.opening_times.grouped.join(" ")}}</label>
			<label class="24h" v-if="poi.opening_times && poi.opening_times['24h']">24h</label>
		</div>
        <div class="poi-overlay">
            <div class="poi-overlay-body">
                <button class="poi-button poi-button-info" v-wf-translate="'button-info'" @click="openPOIInfo(poi)">Info</button>
                <button class="poi-button action"><label v-wf-translate="'button-path'" @click="showPath(poi)">Näita teekonda</label> <icon name="arrow"/></button>
                <div class="poi-name">{{poi.getName(language)}}</div>
            </div>
            <div class="poi-footer">
                <icon name="clock"/>
				
				<label v-if="poi.opening_times && !poi.opening_times['24h']">{{poi.opening_times.grouped.join(" ")}}</label>
				<label v-if="poi.opening_times && poi.opening_times['24h']">24h</label>
				
            </div>
        </div>
	</div>
</template>

<script>
/* global wayfinder: false */
import { mapState } from 'vuex';
import { WFPOI} from '@3dwayfinder/wayfinder-vue-components'


export default {
	name: "POI",
    components: {
        WFPOI
    },
	computed: {
		...mapState('wf', ['language'])
	},
	props: {
		poi: {
			type: Object,
			default: null
		},
		showLogo: {
			type: Boolean,
			default: true
		},
		showName: {
			type: Boolean,
			default: true
		},
		showPathButton: {
			type: Boolean,
			default: true
		},
		showDescription: {
			type: Boolean,
			default: true
		},
		showRoomID: {
			type: Boolean,
			default: false
		},
		showFloor: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		language () {
			if (wayfinder) {
				this.show_path = this.$wayfinder.translator.get('show_path');
			}
		}
	},
	methods: {
		showPath () {
			if (this.poi) {
				this.$emit('showPath', this.poi);
			}
		},
		openPOIInfo (poi) {
			if (poi) {
				this.$store.dispatch('wf/SET_CURRENT_POI', poi);
			}
		},
		getImage () {
			if (typeof this.poi.logo == "string") {
				return 'url("' + this.poi.logo  + '")';
			}

			return ""
		},
	},
	data: function () {
		return {
			show_path: 'Show Path'
		}
	}
};
</script>

<style lang="less" scoped>
    @import '../theme/variables';

	.poi-container {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.poi-image {
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: contain;
		background-image: url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIj48dGl0bGU+UGhvdG88L3RpdGxlPjxnIGlkPSJQaG90byIgc3Ryb2tlPSIjNEE0QTRBIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHJlY3QgaWQ9IlJlY3RhbmdsZS0xNiIgeD0iMi41IiB5PSIyLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIiLz48cGF0aCBpZD0iUGF0aC05IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNNC44NjggMTlsMy43NjYtOS4wNDggNC4yMyA3LjQzNiAyLjQwNC00LjAwN0wxOS4wNjIgMTl6Ii8+PGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjE2IiBjeT0iNy4xMzMzMzMzMyIgcj0iMi4xMzMzMzMzMyIvPjwvZz48bWV0YWRhdGE+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxuczpyZGZzPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwLzAxL3JkZi1zY2hlbWEjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iPjxyZGY6RGVzY3JpcHRpb24gYWJvdXQ9Imh0dHBzOi8vaWNvbnNjb3V0LmNvbS9sZWdhbCNsaWNlbnNlcyIgZGM6dGl0bGU9InBob3RvIiBkYzpkZXNjcmlwdGlvbj0icGhvdG8iIGRjOnB1Ymxpc2hlcj0iSWNvbnNjb3V0IiBkYzpkYXRlPSIyMDE4LTA2LTI4IiBkYzpmb3JtYXQ9ImltYWdlL3N2Zyt4bWwiIGRjOmxhbmd1YWdlPSJlbiI+PGRjOmNyZWF0b3I+PHJkZjpCYWc+PHJkZjpsaT5BdmluYXNoIFA8L3JkZjpsaT48L3JkZjpCYWc+PC9kYzpjcmVhdG9yPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L21ldGFkYXRhPjwvc3ZnPg==');
	}
</style>
